import { catchError } from "rxjs/operators";
import { Helper } from "src/app/shared/helpers/helper";
import { BASE_BACKEND } from "src/app/shared/http/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DashboardService {
    constructor(http) {
        this.http = http;
    }
    openCloseSchedule(queryParams) {
        return this.http
            .get(`${BASE_BACKEND}dashboard/openCloseSchedule?${queryParams}`)
            .pipe(catchError(Helper.handleError));
    }
}
DashboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardService_Factory() { return new DashboardService(i0.ɵɵinject(i1.HttpClient)); }, token: DashboardService, providedIn: "root" });
